import { Skeleton, SkeletonProps } from 'antd';
import classNames from 'classnames';

interface MSkeletonProps extends SkeletonProps {
  repeat?: number;
}

const MSkeleton: React.FC<MSkeletonProps> = (props) => {
  if (props?.repeat) {
    const nodes = Array.from({ length: props.repeat }, (_, index) => (
      <Skeleton.Node
        key={index}
        active
        {...props}
        className={classNames('trojan-skeleton', props.className)}
      />
    ));

    return <div className="trojan-repeated-skeleton">{nodes}</div>;
  }

  return (
    <Skeleton.Node
      active
      {...props}
      className={classNames('trojan-skeleton', props.className)}
    />
  );
};

export default MSkeleton;
